export default "__VITE_ASSET__DMXfu3k7__"